export interface AppSettings {
  PATH_ROOT: string;
  PATH_STATIC: string;
  API_LOGIN: string;
  API_LOGOUT: string;
  API_CIPS: string;
  API_OPERATOR: string;
  API_USER_SERVICES: string;
  API_USER_SET_SERVICE: string;
  API_USER_ALIAS: string;
  API_EXCEL: string;
  API_USER_FILTER: string;
  API_USER: string;
  API_PASSWORD: string;
  API_RECOVER_PASSWORD: string;
  API_REFRESH_TOKEN: string;
  API_VALIDATION_REPORT_TOKEN: string;
  API_VALIDATION_TOKEN_EMAIL: string;
  API_PAYMENT_TYPE: string;
  API_RESEND_OTP: string;
  API_VERIFICATION_OTP: string;
}

let settings: AppSettings;

const whitelist = [
  'https://callcenter.pagoefectivo-dev.com/config.json',
  'https://callcenter.pagoefectivo-pre.com/config.json',
  'https://callcenter.pagoefectivolatam.com/config.json',
  'https://callcenter.pagoefectivo-stg.com/config.json'
];


export async function fetchSettings(): Promise<AppSettings> {

  const configUrl = `${window.location.origin}/config.json`;
  if(whitelist.includes(configUrl)){
      const response = await fetch(configUrl, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Error cargando config: ${response.statusText}`);

    settings = await response.json();
  }
  return settings;
}

export function getSettings(): AppSettings {
  if (!settings) throw new Error('Configuración aún no cargada');
  return settings;
}
